<template>
    <div class="header">
        <vue-particles color="#dedede"
                       :particleOpacity="0.7"
                       :particlesNumber="250"
                       shapeType="circle"
                       :particleSize="4"
                       linesColor="#dedede"
                       :linesWidth="1"
                       :lineLinked="true"
                       :lineOpacity="0.4"
                       :linesDistance="100"
                       :moveSpeed="5"
                       :hoverEffect="false"
                       hoverMode="repulse"
                       :clickEffect="false"
                       clickMode="repulse"></vue-particles>
        <nav class="d-flex">
            <div class="menu">
                <div class="menu-button" @click="toggle">
                    <img src="../assets/menu-min.webp" alt="bouton du menu">
                </div>
                <Drawer @close="toggle" align="left" :closeable="true" :maskClosable="true">
                    <div v-if="open">
                        <div class="menu">
                            <div class="menu-column d-flex flex-column">
                                <router-link class="is-tab nav-item" to="/">Accueil</router-link>
                                <a class="is-tab nav-item" href="#devWeb">Développement Web</a>
                                <a class="is-tab nav-item" href="#conception">Conception</a>
                                <a class="is-tab nav-item" href="#devMobile">Développement Mobile</a>
                                <a class="is-tab nav-item" href="#competences">Compétences</a>
                                <router-link class="is-tab nav-item" to="/portfolio">Portfolio</router-link>
                                <router-link class="is-tab nav-item" to="/contact">Contact</router-link>
                            </div>
                        </div>
                    </div>
                </Drawer>
            </div>
            <div class="div_logo">
                <router-link to="/" class="logo">
                    <img src="../assets/logo-min.webp" id="vwp-logo"
                         alt="Logo NR"/>
                </router-link>
            </div>
            <div class="menu_desktop">
                <router-link to="/" @click.native="scrollFix('#devWeb')">Dev Web</router-link>
                <router-link to="/" @click.native="scrollFix('#conception')">Conception</router-link>
                <router-link to="/" @click.native="scrollFix('#devMobile')">Dev Mobile</router-link>
                <router-link to="/" @click.native="scrollFix('#competences')">Compétences</router-link>
                <router-link class="is-tab nav-item" to="/portfolio">Portfolio</router-link>
                <router-link class="is-tab nav-item" to="/contact">Contact</router-link>
            </div>
        </nav>
    </div>
</template>

<script>
    import Drawer from "vue-simple-drawer"

    export default {
        name: "Header",
        data() {
            return {
                open: false,
            }
        },
        components: {
            Drawer
        },
        props: {
            msg: String
        },
        methods: {
            toggle() {
                this.open = !this.open
            },
            scrollFix: function(hashbang)
            {
                location.hash = hashbang;
            }
        },
        watch: {
            $route() {
                this.open = false
            }
        },
        mounted: function()
        {
            // From testing, without a brief timeout, it won't work.
            setTimeout(() => this.scrollFix(this.$route.hash), 1);
        },
    }
</script>

<style scoped>

    .header {
        background-color: #A52A2A;
        height: 10vh;
        position: fixed;
        z-index: 1000;
        width: 100%;
    }

    #particles-js {
        height: 100%;
        width: 100%;
    }

    nav {
        width: 80%;
        margin-top: -8vh;
        margin-left: 5%;
        margin-right: 5%;
    }

    .menu-button {
        position: relative;
        top: 10px;
        color: white;
    }

    .menu_desktop {
        display: none;
    }

    .div_logo {
        text-align: center;
        width: 85%;
        z-index: 100;
    }

    #vwp-logo {
        width: 50px;
    }

    @media (min-width: 576px) {
        nav {
            width: 85%;
        }

        .div_logo {
            width: 100%;
        }

        #vwp-logo {
            width: 55px;
        }
    }

    @media (min-width: 768px) {
        .nav-item {
            margin-left: 10%;
        }
    }

    @media (min-width: 992px) {
        .menu {
            display: none;
        }

        .menu_desktop {
            display: flex;
            flex-direction: row;
            z-index: 1000;
            justify-content: space-around;
            line-height: 50px;
            width: 100%;
        }

        nav {
            width: 96%;
            margin-left: 2%;
            margin-right: 2%;
        }

        .menu_desktop a {
            color: #363636;
            margin-left: 20px;
            margin-right: 20px;
            text-align: center;
            font-weight: 600;
        }

        .div_logo {
            width: 10%;
        }
    }

    @media (min-width: 1200px) {
        nav {
            margin-top: -9vh;
        }
    }

    @media (min-width: 1600px) {
        nav {
            margin-top: -8vh;
        }
    }

</style>